import { FC, ButtonHTMLAttributes } from 'react';

import PrimaryButton from '~src/shared/buttons/basicButtons/PrimaryButton.sc';
import { ButtonColorTypes, ButtonProps, ButtonSizes } from '~src/shared/buttons/basicButtons/BaseButton.sc';
import { PartialBy } from '~src/types';

import LoadingInner, { LoaderWrapper } from './LoadingInner';

interface OwnProps {
  isLoading: boolean | undefined;
}

type Props = OwnProps &
  PartialBy<ButtonProps, '$buttonColor' | '$buttonSize'> &
  ButtonHTMLAttributes<HTMLButtonElement>;

const PrimaryButtonLoading: FC<Props> = (props) => {
  const mergedProps = {
    $buttonColor: ButtonColorTypes.Blue,
    $buttonSize: ButtonSizes.Medium,
    ...props,
  };
  const { isLoading, ...restProps } = mergedProps;
  return (
    <LoaderWrapper className={isLoading ? 'loading' : ''}>
      <PrimaryButton {...restProps}>
        <LoadingInner
          loaderColor={mergedProps.$buttonColor !== ButtonColorTypes.White ? 'white' : undefined}
          isLoading={isLoading}
        >
          {props.children}
        </LoadingInner>
      </PrimaryButton>
    </LoaderWrapper>
  );
};

export default PrimaryButtonLoading;
